(() => {
  const selector = 'slideshow-component[data-hero-viewport-fit]';
  const headerIds = ['shopify-section-announcement-bar', 'shopify-section-header'];
  const fit = () => {
    const offset = headerIds.reduce((height, id) => {
      return height + (document.getElementById(id)?.getBoundingClientRect().height || 0);
    }, 0);
    document.querySelectorAll(selector).forEach(hero => {
      const value = `${offset}px`;
      if (hero.style.getPropertyValue('--hero-top-offset') !== value) {
        hero.style.setProperty('--hero-top-offset', value);
      }
    });
  };
  if (window.NordwegHeroViewportFit) {
    window.NordwegHeroViewportFit.refresh();
    return;
  }
  let observer;
  const refresh = () => {
    observer?.disconnect();
    fit();
    if ('ResizeObserver' in window) {
      observer = new ResizeObserver(fit);
      headerIds.forEach(id => {
        const header = document.getElementById(id);
        if (header) observer.observe(header);
      });
    }
  };
  window.NordwegHeroViewportFit = { refresh };
  window.addEventListener('resize', fit, { passive: true });
  window.addEventListener('pageshow', refresh);
  document.addEventListener('shopify:section:load', refresh);
  document.fonts?.ready.then(fit);
  refresh();
})();
